<template>
  <el-input v-model="currentValue" type="number" @change="valueChange"
            class="number_input_main">
    <i slot="suffix" class="suffix_icon">{{iconText}}</i>
    <div slot="suffix" class="number_operate">
      <i class="el-icon-caret-top" @click="numberOperate(1)"></i>
      <i class="el-icon-caret-bottom" @click="numberOperate(-1)"></i>
    </div>
  </el-input>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    value: {
      type: [Number, String],
      default () {
        return undefined
      }
    },
    iconText: {
      type: String,
      default () {
        return '';
      }
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    }
  },
  methods: {
    numberOperate (num) {
      if (this.value !== undefined) {
        this.$emit('input', Number(this.currentValue) + num)
      } else {
        this.$emit('input', num)
      }
      this.$emit('change')
    },
    valueChange (value) {
      if (value !== this.value) {
        this.$emit('input', value)
        this.$emit('change')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.number_input_main {
  .suffix_icon {
    line-height: 40px;
    padding-right: 5px;
  }
  .number_operate {
    display: none;
    position: absolute;
    top: 5px;
    left: 0;
    width: 18px;
    height: 30px;
    border: 1px solid #E9E9E9;
    border-radius: 9px;
    background: #FFF;
    i {
      cursor: pointer;
      line-height: 14px;
      height: 14px;
      &:last-child {
        position: relative;
        top: -4px;
      }
    }
  }
  &:hover {
    .number_operate {
      display: block;
    }
  }
}
</style>
